import { React, useState, useEffect } from "react";
import { Layout, Row, Col, Form, Input, Button } from "antd";
import {
  FullHeightRow,
  AuthLeftContainer,
  HaberForm,
  AuthTitleBlock,
} from "../styledElements";
import AuthRightContainer from "../../Components/AuthRightBox/authRightContainer";
import Logo from "../../Assets/Images/logo.svg";
import { Link, useLocation } from "react-router-dom";
import { usePasswordValidation } from "../../hooks/usePasswordValidation";
import correctIcon from "../../Assets/Icons/correct.svg";
import wrongIcon from "../../Assets/Icons/wrong.svg";
import { useSearchParams } from "react-router-dom";
import { createAccount } from "../../Services/loginServices";
import { useNavigate } from "react-router-dom";
import { useUserNameValidation } from "../../hooks/useUserNameValidation";
import { authenticateUser } from "../../Services/loginServices";
import { getUserProfile } from "../../Services/loginServices";
import { getCompanyDetails } from "../../Services/companyServices";
import store from "../../ReduxStore/store";
import { ActionTypes } from "../../Constants/ActionTypes";

const validateMessages = {
  required: "This field is required !",
  types: {
    email: "Email is not a valid email!",
  },
};

const Signup = (props) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState();
  const [password, setPassword] = useState({
    firstPassword: "",
    secondPassword: "",
  });
  let [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const [userEmail, setUserEmail] = useState(
    location.state == undefined
      ? searchParams.get("username")
      : location.state.email
  );

  const [validLength, hasNumber, upperCase, lowerCase, match, specialChar] =
    usePasswordValidation({
      firstPassword: password.firstPassword,
      secondPassword: password.secondPassword,
    });

  const [userIsAlphaNumeric, userValidLength] = useUserNameValidation(username);

  const setFirst = (event) => {
    setPassword({ ...password, firstPassword: event.target.value });
  };
  const setSecond = (event) => {
    setPassword({ ...password, secondPassword: event.target.value });
  };
  const onFinish = async (values) => {
    console.log("Received values of form: ", values);
    try {
      //To be added:Add temporary password.
      const createAccountResponse = await createAccount(
        userEmail,
        values.username,
        values.password,
        location.state.temporaryPassword
      );
      if (!createAccountResponse.error){
        try {
          const authenticateResponse = await authenticateUser(userEmail, values.password);
          if (!authenticateResponse.data.error) {
            const userProfile = await getUserProfile();
            localStorage.setItem("user-details", JSON.stringify(userProfile));
            getCompanyDetails()
              .then((response) => {
                localStorage.setItem("company", JSON.stringify(response.data))
              })
              .catch((error) => {
                console.log("Error in getting company details:", error.response.data);
              });
            store.dispatch({
              type: ActionTypes.loginActions.SET_USER_PROFILE,
              data: {
                email: userEmail,
              },
            });
            navigate("/landing-page", { replace: true });
          }
        } catch (error) {
          console.log("Error response from login", error.response);
          //To be done:If a user login's for the first time using his temporary password,he should be redirected to create-account page.
          if (error.response?.data?.data == null) {
            navigate("/login", { replace: true });
          } 
        } finally {
        }
      }
    } catch (error) {
      // To be done:Incorrect temporary password and errors should be redirected to error message modal
      console.log(error);
    }
  };

  const setUserName = (event) => {
    event.preventDefault();
    setUsername(event.target.value);
  };
  useEffect(() => {
    console.log("email inside create account from location state", location);
  }, []);

  return (
    <FullHeightRow>
      <Layout className="authLayout" style={{ backgroundColor: "#ffffff" }}>
        <Row span={24}>
          <Col span={12} className="colLayoutBlock">
            <AuthLeftContainer>
              <div className="flexBlock" style={{ justifyContent: "center" }}>
                <div className="vCenterBlock">
                  <div className="hCenterBox">
                    <AuthTitleBlock>
                      <div className="logo">
                        <img src={Logo} alt="HaberERP" />
                      </div>
                      <h1>Create your account</h1>
                    </AuthTitleBlock>
                    <HaberForm>
                      <Form
                        name="basic"
                        autoComplete="off"
                        className="haberLogin haberSignup"
                        validateMessages={validateMessages}
                        onFinish={onFinish}
                      >
                        <Form.Item
                          name="useremail"
                          rules={[{ type: "email" }]}
                          className="mailIcon"
                        >
                          <Input
                            placeholder="Enter your email"
                            defaultValue={userEmail}
                            // value={userEmail}
                            disabled
                          />
                        </Form.Item>

                        <Form.Item
                          name="username"
                          rules={[
                            { required: true },
                            {
                              min: 3,
                              message:
                                "Minimum 3 and maximum 50 characters are required",
                            },
                            {
                              max: 50,
                              message:
                                "Minimum 3 and maximum 50 characters are required",
                            },
                            {
                              validator: () => {
                                if (userIsAlphaNumeric)
                                  return Promise.resolve();
                                else
                                  return Promise.reject(
                                    "Only alphanumeric characters are allowed"
                                  );
                              },
                            },
                          ]}
                          className="userIcon"
                        >
                          <Input
                            placeholder="Enter your name"
                            style={{ textTransform: "capitalize" }}
                            onChange={setUserName}
                          />
                        </Form.Item>

                        <Form.Item
                          name="password"
                          rules={[{ required: true }]}
                          className="lockIcon firstPass"
                        >
                          <Input.Password
                            placeholder="Enter your password"
                            onChange={setFirst}
                            autoComplete="new-password"
                          />
                        </Form.Item>

                        <Form.Item
                          name="confirmpassword"
                          rules={[{ required: true }]}
                          className="lockIcon"
                        >
                          <Input.Password
                            placeholder="Confirm password"
                            onChange={setSecond}
                          />
                        </Form.Item>

                        <ul className="pwdStrength">
                          <li>
                            {validLength ? (
                              <span>
                                <img src={correctIcon} alt="correct" />
                              </span>
                            ) : (
                              <span>
                                <img src={wrongIcon} alt="wrong" />
                              </span>
                            )}{" "}
                            Atleast 8 characters long
                          </li>
                          <li>
                            {hasNumber ? (
                              <span>
                                <img src={correctIcon} alt="correct" />
                              </span>
                            ) : (
                              <span>
                                <img src={wrongIcon} alt="wrong" />
                              </span>
                            )}{" "}
                            One numeric charater
                          </li>
                          <li>
                            {upperCase ? (
                              <span>
                                <img src={correctIcon} alt="correct" />
                              </span>
                            ) : (
                              <span>
                                <img src={wrongIcon} alt="wrong" />
                              </span>
                            )}{" "}
                            One uppercase character
                          </li>
                          <li>
                            {lowerCase ? (
                              <span>
                                <img src={correctIcon} alt="correct" />
                              </span>
                            ) : (
                              <span>
                                <img src={wrongIcon} alt="wrong" />
                              </span>
                            )}{" "}
                            One lowercase character
                          </li>
                          <li>
                            {specialChar ? (
                              <span>
                                <img src={correctIcon} alt="correct" />
                              </span>
                            ) : (
                              <span>
                                <img src={wrongIcon} alt="wrong" />
                              </span>
                            )}{" "}
                            One special character{" "}
                          </li>
                          <li>
                            {match ? (
                              <span>
                                <img src={correctIcon} alt="correct" />
                              </span>
                            ) : (
                              <span>
                                <img src={wrongIcon} alt="wrong" />
                              </span>
                            )}{" "}
                            Password matching
                          </li>
                        </ul>

                        <Form.Item>
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="btnSubmit"
                            disabled={
                              validLength &&
                              hasNumber &&
                              upperCase &&
                              lowerCase &&
                              match &&
                              specialChar
                                ? false
                                : true
                            }
                          >
                            {" "}
                            Create your account{" "}
                          </Button>
                        </Form.Item>
                      </Form>
                      <div className="pageLinks">
                        <Link to="/privacy-policy">Privacy Policy</Link> |{" "}
                        <Link to="/terms-and-conditions">
                          Terms {"&"} Conditions
                        </Link>
                      </div>
                    </HaberForm>
                  </div>
                </div>
              </div>
            </AuthLeftContainer>
          </Col>
          <Col span={12} className="colLayoutBlock">
            <AuthRightContainer />
          </Col>
        </Row>
      </Layout>
    </FullHeightRow>
  );
};

export default Signup;
